import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

function ProfilePage() {
  const { memberId } = useParams();
  const [member, setMember] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMemberProfile = async () => {
      try {
        const response = await fetch(`https://members.abssvss.com/members_api/get_member_profile.php?id=${memberId}`);
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Member not found.');
        }
        const data = await response.json();
        setMember(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMemberProfile();
  }, [memberId]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
  };

  if (isLoading) return <div className="text-center text-gray-700">Loading profile...</div>;
  if (error) return <div className="text-center text-red-500 bg-red-100 p-8 rounded-lg shadow-lg">Error: {error}</div>;

  return (
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl border-t-4 border-brand-accent">
        <div className="flex flex-col items-center">
            <img 
                src={member.profilePictureUrl ? `https://members.abssvss.com${member.profilePictureUrl}` : `https://ui-avatars.com/api/?name=${member.firstName}+${member.lastName}&background=8b0000&color=fff&size=128`}
                alt={`${member.firstName} ${member.lastName}`}
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-200 mb-4"
                onError={(e) => { e.target.onerror = null; e.target.src=`https://ui-avatars.com/api/?name=${member.firstName}+${member.lastName}&background=8b0000&color=fff&size=128` }}
            />

            <h1 className="text-4xl font-bold text-brand-primary">{member.firstName} {member.lastName}</h1>
            <p className="text-xl text-gray-600 font-medium">{member.position || 'Member'}</p>
            <p className="text-md text-gray-500 font-semibold mt-1">{member.memberId}</p>
            
            <div className="border-t border-gray-200 w-full my-6"></div>

            <div className="w-full text-left grid grid-cols-1 md:grid-cols-2 gap-4 text-lg">
                <div className="bg-gray-50 p-4 rounded-lg">
                    <span className="font-bold text-gray-700">State:</span> {member.state}
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                    <span className="font-bold text-gray-700">City:</span> {member.city || 'N/A'}
                </div>
                <div className="bg-gray-50 p-4 rounded-lg col-span-1 md:col-span-2">
                    <span className="font-bold text-gray-700">Date of Joining:</span> {formatDate(member.joiningDate)}
                </div>
            </div>
            {member.bio && (
                <div className="w-full text-left mt-4 bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-bold text-gray-700 mb-2">About:</h3>
                    <p className="text-gray-600">{member.bio}</p>
                </div>
            )}
        </div>
    </div>
  );
}

export default ProfilePage;

